var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSolidSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "8px",
    viewBox: "0 0 5 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-151.000000, -437.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.266267,438.517428 C150.911244,438.170296 150.911244,437.607482 151.266267,437.26035 C151.621289,436.913217 152.196893,436.913217 152.551915,437.26035 L155.733733,440.371461 C156.088756,440.718593 156.088756,441.281407 155.733733,441.628539 L152.551915,444.73965 C152.196893,445.086783 151.621289,445.086783 151.266267,444.73965 C150.911244,444.392518 150.911244,443.829704 151.266267,443.482572 L153.80526,441 L151.266267,438.517428 Z",
    id: "Next"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSolidSmall);
export default __webpack_public_path__ + "static/media/ArrowSolidSmall.6bbb494d5c8a77dc65fe9d1906d22140.svg";
export { ForwardRef as ReactComponent };